import React from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { isClientSide } from 'utils/host-config';
import { SOLD_BUTTON_ID, RENTED_BUTTON_ID, type ButtonId } from './constants';

export { SOLD_BUTTON_ID, RENTED_BUTTON_ID };
export type { ButtonId };

type ButtonGroupProps = {
  activeButton: ButtonId;
  onButtonClick?: (buttonId: ButtonId) => void;
};

const useIsomorphicLayoutEffect = isClientSide() ? React.useLayoutEffect : () => { /* useLayoutEffect does nothing on the server */ };

export default function ButtonGroup({ activeButton, onButtonClick }: ButtonGroupProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  const onButtonClickRef = React.useRef(onButtonClick);

  useIsomorphicLayoutEffect(() => {
    onButtonClickRef.current = onButtonClick;
  }, [onButtonClick]);

  const isSoldActive = activeButton === SOLD_BUTTON_ID;
  const isRentedActive = activeButton === RENTED_BUTTON_ID;

  return (
    <div className={styles['button-group']}>
      <button id={SOLD_BUTTON_ID} onClick={() => onButtonClickRef.current?.(SOLD_BUTTON_ID)} className={buildClassName(isSoldActive && styles.active)}>
        {t(LOCALE_COMMON_PATHS.PRICE_HISTORY_SOLD_BUTTON_GROUP)}
      </button>
      <button id={RENTED_BUTTON_ID} onClick={() => onButtonClickRef.current?.(RENTED_BUTTON_ID)} className={buildClassName(isRentedActive && styles.active)}>
        {t(LOCALE_COMMON_PATHS.PRICE_HISTORY_RENTED_BUTTON_GROUP)}
      </button>
    </div>
  );
}
